import React from 'react';
import styles from './spinner.module.scss';
import { Typography } from 'antd';
const { Text } = Typography;

const Spinner: React.FC = () => {
  const cssClasses = [styles.cipherLoader, styles.infinite, styles.huge].join(
    ' ',
  );

  return (
    <div className={cssClasses}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 494 494">
        <path
          className={`${styles.dotAnim} ${styles.topRight1}`}
          d="M467.3,236.1c-13,7.5-29.5,3-37-9.9c-7.5-12.9-3-29.5,9.9-37c13-7.5,29.5-3,37,9.9C484.8,212,480.3,228.6,467.3,236.1"
        />
        <path
          className={`${styles.dotAnim} ${styles.topRight2}`}
          d="M391.1,229c-18.8,10.8-42.8,4.4-53.6-14.3c-10.8-18.7-4.4-42.6,14.3-53.5c18.8-10.8,42.8-4.4,53.6,14.4C416.3,194.3,409.9,218.2,391.1,229"
        />
        <path
          className={`${styles.dotAnim} ${styles.topRight3}`}
          d="M332.4,102.7c10.8,18.7,4.4,42.7-14.4,53.5c-18.8,10.8-42.7,4.4-53.6-14.3c-10.8-18.7-4.4-42.7,14.4-53.5C297.6,77.6,321.6,84,332.4,102.7"
        />
        <path
          className={`${styles.dotAnim} ${styles.topRight4}`}
          d="M305.2,26.6c7.5,12.9,3,29.5-9.9,37c-13,7.5-29.6,3-37-9.9c-7.5-13-3-29.5,9.9-37C281.1,9.3,297.7,13.7,305.2,26.6"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomRight1}`}
          d="M467.4,305.3c-13,7.5-29.5,3-37-9.9c-7.5-12.9-3-29.5,9.9-36.9c13-7.5,29.6-3,37,9.9C484.8,281.3,480.3,297.8,467.4,305.3"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomRight2}`}
          d="M391.1,332.5c-18.8,10.8-42.8,4.4-53.6-14.3c-10.8-18.7-4.4-42.6,14.4-53.5c18.8-10.8,42.8-4.4,53.6,14.4C416.3,297.7,409.9,321.7,391.1,332.5"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomRight3}`}
          d="M264.5,391.1c-10.8-18.7-4.4-42.7,14.4-53.5c18.8-10.8,42.8-4.4,53.6,14.3c10.8,18.7,4.4,42.7-14.4,53.5C299.4,416.2,275.4,409.8,264.5,391.1"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomRight4}`}
          d="M257.5,467.1c-7.5-12.9-3-29.5,9.9-36.9c13-7.5,29.6-3,37,9.9c7.5,12.9,3,29.5-9.9,37C281.5,484.5,265,480,257.5,467.1"
        />
        <path
          className={`${styles.dotAnim} ${styles.topLeft1}`}
          d="M52.9,235.2c-12.9,7.4-29.3,3-36.8-9.8c-7.4-12.9-3-29.3,9.8-36.7c12.9-7.4,29.3-3,36.8,9.8C70.2,211.3,65.8,227.8,52.9,235.2"
        />
        <path
          className={`${styles.dotAnim} ${styles.topLeft2}`}
          d="M102.1,161.3c18.8-10.8,42.8-4.4,53.6,14.3c10.8,18.7,4.4,42.6-14.3,53.5c-18.8,10.8-42.8,4.4-53.6-14.3C76.9,196,83.4,172.1,102.1,161.3"
        />
        <path
          className={`${styles.dotAnim} ${styles.topLeft3}`}
          d="M228.7,102.7c10.8,18.7,4.4,42.7-14.4,53.5c-18.8,10.8-42.7,4.4-53.6-14.3c-10.8-18.7-4.4-42.7,14.4-53.5C193.9,77.6,217.9,84,228.7,102.7"
        />
        <path
          className={`${styles.dotAnim} ${styles.topLeft4}`}
          d="M235.8,26.7c7.5,12.9,3,29.5-9.9,36.9c-13,7.5-29.5,3-37-9.9c-7.5-12.9-3-29.5,9.9-37C211.7,9.3,228.3,13.7,235.8,26.7"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomLeft1}`}
          d="M52.9,306.2c-12.9,7.4-29.3,3-36.8-9.8c-7.4-12.8-3-29.3,9.9-36.7c12.9-7.4,29.3-3,36.8,9.8C70.2,282.3,65.8,298.8,52.9,306.2"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomLeft2}`}
          d="M102.2,264.8c18.8-10.8,42.7-4.4,53.6,14.3c10.9,18.7,4.4,42.7-14.3,53.5c-18.8,10.8-42.8,4.4-53.6-14.3C77,299.5,83.4,275.6,102.2,264.8"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomLeft3}`}
          d="M160.9,391.1c-10.8-18.7-4.4-42.7,14.4-53.5c18.8-10.8,42.7-4.4,53.6,14.3c10.8,18.7,4.4,42.7-14.4,53.5C195.7,416.2,171.7,409.8,160.9,391.1"
        />
        <path
          className={`${styles.dotAnim} ${styles.bottomLeft4}`}
          d="M188.1,467.1c-7.5-12.9-3-29.5,9.9-36.9c13-7.5,29.6-3,37,9.9c7.5,12.9,3,29.5-9.9,37C212.2,484.5,195.6,480,188.1,467.1"
        />
      </svg>
      <Text className={styles.status}>Loading</Text>
    </div>
  );
};

export default Spinner;
